import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import PageSeo from "../components/PageSeo";
import PageTopbar from "../components/PageTopbar";
import { buildBreadcrumbNavItems } from "../lib/pageSeo";
import { ND1_SIGNUP } from "./nd1Paths";
import Nd1SiteNav from "./components/Nd1SiteNav";
import Nd1SiteFooter from "./components/Nd1SiteFooter";
import { Nd1GreenTickIcon } from "./components/Nd1TickIcons";
import "./nd1.css";

const HIRING_SIGNUP = `${ND1_SIGNUP}?type=hiring-manager`;

const INCLUDED_POINTS = [
  "50 job posts when you sign up — use them whenever you're ready",
  "Video introductions from genuine applicants",
  "One pipeline for every role you advertise",
  "No credit card needed to get started",
];

export default function Nd1LaunchFreePage() {
  return (
    <div className="nd1-root nd1-root--hiring">
      <PageSeo
        title="It's free for hiring managers"
        description="Post jobs on JOBUWIN during our launch — 50 job slots included when you sign up. No credit card required."
        path="/pricing"
        canonicalPath="/pricing"
      />
      <a href="#nd1-main" className="nd1-skip-link">
        Skip to content
      </a>
      <Nd1SiteNav />

      <main id="nd1-main">
        <section className="nd1-shell nd1-hm-hero nd1-launch-free-hero">
          <PageTopbar
            breadcrumbsOnly
            breadcrumbItems={buildBreadcrumbNavItems([
              { name: "Home", path: "/" },
              { name: "Pricing", path: "/pricing", current: true },
            ])}
          />

          <div className="nd1-hm-hero__grid">
            <div className="nd1-hm-hero__content nd1-launch-free-hero__content">
              <span className="nd1-eyebrow-chip">
                <Sparkles className="nd1-icon" aria-hidden="true" />
                For hiring managers
              </span>
              <h1 className="nd1-hm-hero__title">
                <span>It&apos;s</span>
                <span className="nd1-ink-green">FREE</span>
              </h1>
              <p className="nd1-hm-hero__copy">
                Sign up as a hiring manager and start posting jobs straight away. No checkout, no credit card.
              </p>
              <div className="nd1-hm-hero__actions">
                <Link to={HIRING_SIGNUP} className="nd1-btn nd1-btn--accent">
                  Get started
                  <ArrowRight className="nd1-icon" aria-hidden="true" />
                </Link>
                <Link to="/how-it-works/hiring" className="nd1-btn nd1-btn--outline">
                  See how it works
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="nd1-shell nd1-section nd1-launch-free-section">
          <div className="nd1-hm-section-head nd1-hm-section-head--wide">
            <h2 className="nd1-hm-section-head__title">What you get</h2>
            <p className="nd1-hm-section-head__copy">
              Everything you need to start hiring genuine applicants — included when you create your account.
            </p>
          </div>

          <article className="nd1-launch-free-card nd1-card">
            <ul className="nd1-check-list">
              {INCLUDED_POINTS.map((point) => (
                <li key={point} className="nd1-check-list__item">
                  <Nd1GreenTickIcon className="nd1-icon" aria-hidden="true" />
                  {point}
                </li>
              ))}
            </ul>
            <p className="nd1-launch-free-card__footnote">
              Job slots don&apos;t expire — publish a role when you&apos;re ready and start receiving applications.
            </p>
          </article>
        </section>

        <section className="nd1-shell nd1-section nd1-pricing-cta-band">
          <div className="nd1-pricing-cta-band__inner nd1-panel">
            <h2 className="nd1-pricing-cta-band__title">Ready to hire genuine applicants?</h2>
            <p className="nd1-pricing-cta-band__copy">
              Create your hiring account and post your first job — it&apos;s free right now.
            </p>
            <Link to={HIRING_SIGNUP} className="nd1-btn nd1-btn--accent">
              Get started
              <ArrowRight className="nd1-icon" aria-hidden="true" />
            </Link>
          </div>
        </section>
      </main>

      <Nd1SiteFooter />
    </div>
  );
}
